const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);


  return ['r', 'g', 'b'].reduce((acc, curr, i) => {
    return {
      ...acc,
      [curr]: !result ? 0 : parseInt(result[i + 1], 16),
    };
  }, {}) as any;
};

export default hexToRgb;
